import React from 'react';
import { RemoveFiltersFlat as Delete } from '@fabric-ui/icons';
import { Button, SxProps } from '@mui/material';

interface Props {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  sx?: SxProps;
  disabled?: boolean;
}

export default function ClearSelection({ onClick, sx, disabled = false }: Props) {
  return (
    <Button sx={{ gap: '4px', ...sx }} disabled={disabled} onClick={onClick}>
      <Delete style={{ height: 18, width: 18 }} />
      Clear Selection
    </Button>
  );
}
